export const sluggify = (word: string): string =>
  word
    ?.toLowerCase()
    .replace(/[^\w\s]/gi, '')
    .replace(/ /g, '_'); // Please dont change this to `-`. Some logic has been baked with this

const upperCaseFirst = (word: string) => word && word[0].toUpperCase() + word.slice(1);

export const makeSystemNameUserFriendly = (word: string): string => word.toLowerCase().split('_').map(upperCaseFirst).join(' ');

export function isDigitsOnly(value: string): boolean {
  return /^\d+$/.test(value);
}

export function formatDigitsOnlyToPhoneNumber(phoneDigits: string): string {
  // Given 'XXXXXXXXXX', format phone number as '(XXX) XXX-XXXX'
  const match = phoneDigits.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneDigits;
}
